import { render, staticRenderFns } from "./CsSolicitudesNacDetalle.vue?vue&type=template&id=35d1ea0c"
import script from "./CsSolicitudesNacDetalle.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesNacDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports